import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Button, FormGroup, Label, Input } from "reactstrap";
import TextField from '@mui/material/TextField';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { makeStyles } from "@material-ui/core/styles";
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { IconButton } from '@material-ui/core';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';

import Module_Alert_Confirmation from "./Module_Alert_Confirmation";

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}


const useStyles = makeStyles((theme) => ({

    dialog: {
        position: 'absolute',
        // left: 10,
        top: 400
    },

    paper: {
        overflowY: 'unset',
    },
    customizedButton: {
        position: 'absolute',
        left: '98%',
        top: '-3%',
        backgroundColor: 'lightgray',
        color: 'gray',
    },
}));


function New_C_Header_2025() {

    const classes = useStyles();

    const [display_alert_mysy, setdisplay_alert_mysy] = useState("");
    const [alert_message, setalert_message] = useState("");
    const [alert_type, setalert_type] = useState("");

    function clear_alert_message() {
        setalert_message("");
    }
    function clear_alert_type() {
        setalert_type("");
    }

    function clear_display_alert_mysy() {
        setdisplay_alert_mysy("");
    }


    return (
        <div className="new_s_header_2025">

            {/***  Affichage des messages d'alerte*/}
            {display_alert_mysy && String(display_alert_mysy) === "1" &&
                <Module_Alert_Confirmation alert_message={alert_message}
                    alert_type={alert_type}
                    clear_alert_message={clear_alert_message}
                    clear_alert_type={clear_alert_type}
                    clear_display_alert_mysy={clear_display_alert_mysy}
                />
            }
            {/*** FIN Affichage des messages d'alerte*/}


            <div className="header-menu">
      <div className="logo-menu">
        <img src="/img/c_header_logo.png" alt="Logo MySy" className="logo" />
        
        <div className="menu-list">
          <a href="/apropos" className="menu-link">À propos</a>
          <a href="/fonctionnalites" className="menu-link">Fonctionnalités</a>
          <a href="/tarif" className="menu-link">Tarifs</a>
          <a href="/Recherche-Article-formation" className="menu-link">Blog</a>
          <div className="separator"></div>
          <a href="/marketplace" className="menu-link">Marketplace</a>
        </div>
      </div>

      <div className="cta-login">
        <div className="cta-buttons">
          <button className="btn btn-outline">Créer un compte</button>
          <button className="btn btn-primary">Réserver une démo</button>
        </div>
        <div className="separator"></div>
        <div className="login-link">
          <img src="/img/user.png" alt="User" className="user-icon" />
          <span>Connexion</span>
        </div>
      </div>
    </div>

        </div>
    );
}

export default New_C_Header_2025;

